export default "__VITE_ASSET__2a9464be__"